export default {
  'zh-CN': {
    routeTitles: {
      home: '开发调试面板 - Fuzozo',
      appDownload: 'APP 下载 - Fuzozo',
      privacyPolicy: '隐私政策 - Fuzozo',
      userAgreement: '用户服务协议 - Fuzozo',
      registerHelp: '注册帮助 - Fuzozo',
      deviceHelpQa: '帮助 QA - Fuzozo',
      digitalLifeQa: '数字生命 QA - Fuzozo',
      newbieTask: '新手任务 - Fuzozo',
      dailyTask: '成长任务 - Fuzozo',
      growthReward: '成长奖励来信 - Fuzozo',
      personalInfoCollection: '个人信息收集清单 - Fuzozo',
      thirdPartySharing: '第三方信息共享清单 - Fuzozo',
      dataDeletion: '数据删除说明 - Fuzozo',
      instagram: 'Instagram - Fuzozo',
      youtube: 'YouTube - Fuzozo',
      tiktok: 'TikTok - Fuzozo',
      x: 'X - Fuzozo',
      line: 'Line - Fuzozo',
      notFound: '页面未找到 - Fuzozo',
      default: 'Fuzozo'
    }
  },
  en: {
    routeTitles: {
      home: '开发调试面板 - Fuzozo',
      appDownload: 'App Download - Fuzozo',
      privacyPolicy: 'Privacy Policy - Fuzozo',
      userAgreement: 'User Service Agreement - Fuzozo',
      registerHelp: 'Registration Help - Fuzozo',
      deviceHelpQa: 'Help Q&A - Fuzozo',
      digitalLifeQa: 'Digital Life Q&A - Fuzozo',
      newbieTask: 'Beginner Task - Fuzozo',
      dailyTask: 'Growth Task - Fuzozo',
      growthReward: 'Growth Reward Letter - Fuzozo',
      personalInfoCollection: 'Personal Information Collection List - Fuzozo',
      thirdPartySharing: 'Third-Party Information Sharing List - Fuzozo',
      dataDeletion: 'Data Deletion Instructions - Fuzozo',
      instagram: 'Instagram - Fuzozo',
      youtube: 'YouTube - Fuzozo',
      tiktok: 'TikTok - Fuzozo',
      x: 'X - Fuzozo',
      line: 'Line - Fuzozo',
      notFound: 'Page Not Found - Fuzozo',
      default: 'Fuzozo'
    }
  },
  ja: {
    routeTitles: {
      home: '开发调试面板 - Fuzozo',
      appDownload: 'アプリダウンロード - Fuzozo',
      privacyPolicy: 'プライバシーポリシー - Fuzozo',
      userAgreement: '利用規約 - Fuzozo',
      registerHelp: '登録ヘルプ - Fuzozo',
      deviceHelpQa: 'ヘルプQ&A - Fuzozo',
      digitalLifeQa: 'デジタルライフQ&A - Fuzozo',
      newbieTask: '初心者タスク - Fuzozo',
      dailyTask: '成長タスク - Fuzozo',
      growthReward: '成長報酬レター - Fuzozo',
      personalInfoCollection: '個人情報収集一覧 - Fuzozo',
      thirdPartySharing: '第三者情報共有一覧 - Fuzozo',
      dataDeletion: 'データ削除案内 - Fuzozo',
      instagram: 'Instagram - Fuzozo',
      youtube: 'YouTube - Fuzozo',
      tiktok: 'TikTok - Fuzozo',
      x: 'X - Fuzozo',
      line: 'Line - Fuzozo',
      notFound: 'ページが見つかりません - Fuzozo',
      default: 'Fuzozo'
    }
  },
  'zh-TW': {
    routeTitles: {
      home: '开发调试面板 - Fuzozo',
      appDownload: 'APP 下載 - Fuzozo',
      privacyPolicy: '隱私政策 - Fuzozo',
      userAgreement: '使用者服務協議 - Fuzozo',
      registerHelp: '註冊幫助 - Fuzozo',
      deviceHelpQa: '幫助 QA - Fuzozo',
      digitalLifeQa: '數位生命 QA - Fuzozo',
      newbieTask: '新手任務 - Fuzozo',
      dailyTask: '成長任務 - Fuzozo',
      growthReward: '成長獎勵來信 - Fuzozo',
      personalInfoCollection: '個人資訊蒐集清單 - Fuzozo',
      thirdPartySharing: '第三方資訊共享清單 - Fuzozo',
      dataDeletion: '資料刪除說明 - Fuzozo',
      instagram: 'Instagram - Fuzozo',
      youtube: 'YouTube - Fuzozo',
      tiktok: 'TikTok - Fuzozo',
      x: 'X - Fuzozo',
      line: 'Line - Fuzozo',
      notFound: '頁面不存在 - Fuzozo',
      default: 'Fuzozo'
    }
  }
}
